import React, { type ReactNode } from 'react';
import styled from 'styled-components';
import sparklesSvg from '../img/sparkles.svg';

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 500px;
  padding: 30px;
  text-align: center;
`;

const Sparkles = styled.img`
  margin-bottom: -50px;
`;

const Spacer = styled.div`
  margin: 15px 0;
`;

type SuccessMessageProps = {
  children?: ReactNode;
  cta?: ReactNode;
  title?: string;
};

export default function SuccessMessage({
  children,
  cta,
  title,
}: SuccessMessageProps) {
  return (
    <Container>
      <Sparkles src={sparklesSvg} alt="" aria-hidden />
      <h2 className="font-brand-light">{title}</h2>
      {children && <Spacer>{children}</Spacer>}
      {cta && <Spacer>{cta}</Spacer>}
    </Container>
  );
}
